"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactFormRegular = void 0;

var react_1 = __importStar(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var components_1 = require("../../components");

var elements_1 = require("../../elements");

var utils_1 = require("../../utils");

var image_captcha_1 = require("../image-captcha");

var email_form_1 = require("./email-form");

var json = __importStar(require("./localization.json"));

var ContactFormRegular = function ContactFormRegular(_a) {
  var language = _a.language,
      theme = _a.theme,
      reasonsDropdown = _a.reasonsDropdown,
      pageOrigin = _a.pageOrigin,
      apiHost = _a.apiHost,
      apiParcel = _a.apiParcel,
      localizedTexts = _a.localizedTexts,
      _b = _a.isSingleOption,
      isSingleOption = _b === void 0 ? false : _b,
      version = _a.version;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);

  if (!localizedTexts) {
    localizedTexts = {
      formButtonSend: localizedStrings.sharedContent.pages.pageContact.formButtonSend,
      formCity: localizedStrings.sharedContent.pages.pageContact.formCity,
      formCityPlaceholder: localizedStrings.sharedContent.pages.pageContact.formCityPlaceholder,
      formEmail: localizedStrings.sharedContent.pages.pageContact.formEmail,
      formEmailPlaceholder: localizedStrings.sharedContent.pages.pageContact.formEmailPlaceholder,
      formFirstname: localizedStrings.sharedContent.pages.pageContact.formFirstname,
      formFirstnamePlaceholder: localizedStrings.sharedContent.pages.pageContact.formFirstnamePlaceholder,
      formMessage: localizedStrings.sharedContent.pages.pageContact.formMessage,
      formMessagePlaceholder: localizedStrings.sharedContent.pages.pageContact.formMessagePlaceholder,
      formNumber: localizedStrings.sharedContent.pages.pageContact.formNumber,
      formNumberPlaceholder: localizedStrings.sharedContent.pages.pageContact.formNumberPlaceholder,
      formPostcode: localizedStrings.sharedContent.pages.pageContact.formPostcode,
      formPostcodePlaceholder: localizedStrings.sharedContent.pages.pageContact.formPostcodePlaceholder,
      formReason: localizedStrings.sharedContent.pages.pageContact.formReason,
      formStreet: localizedStrings.sharedContent.pages.pageContact.formStreet,
      formStreetPlaceholder: localizedStrings.sharedContent.pages.pageContact.formStreetPlaceholder,
      formSurname: localizedStrings.sharedContent.pages.pageContact.formSurname,
      formSurnamePlaceholder: localizedStrings.sharedContent.pages.pageContact.formSurnamePlaceholder,
      leadText: localizedStrings.sharedContent.pages.pageContact.leadText,
      legendPerson: localizedStrings.sharedContent.pages.pageContact.legendPerson,
      legendReason: localizedStrings.sharedContent.pages.pageContact.legendReason,
      sentEmailText: localizedStrings.sharedContent.pages.pageContact.sentEmailText,
      sentEmailTitle: localizedStrings.sharedContent.pages.pageContact.sentEmailTitle,
      subTitle: localizedStrings.sharedContent.pages.pageContact.subTitle,
      title: localizedStrings.sharedContent.pages.pageContact.title
    };
  }

  var _c = (0, react_1.useState)({}),
      emailFormState = _c[0],
      setEmailFormState = _c[1];

  var _d = (0, react_1.useState)(false),
      isEmailSent = _d[0],
      setIsEmailSent = _d[1];

  var _e = (0, react_1.useState)(null),
      errorFirstName = _e[0],
      setErrorFirstName = _e[1];

  var _f = (0, react_1.useState)(null),
      errorSurName = _f[0],
      setErrorSurName = _f[1];

  var _g = (0, react_1.useState)(null),
      errorEmailAddress = _g[0],
      setErrorEmailAddress = _g[1];

  var _h = (0, react_1.useState)(null),
      errorReason = _h[0],
      setErrorReason = _h[1];

  var _j = (0, react_1.useState)(null),
      errorMessage = _j[0],
      setErrorMessage = _j[1];

  var _k = (0, react_1.useState)(false),
      errorCaptcha = _k[0],
      setErrorCaptcha = _k[1];

  var _l = (0, react_1.useState)(false),
      captchaMatch = _l[0],
      setCaptchaMatch = _l[1];

  var _m = (0, react_1.useState)(),
      captchaInput = _m[0],
      setCaptchaInput = _m[1];

  var _o = (0, react_1.useState)((0, utils_1.randomString)(6)),
      captchaValue = _o[0],
      setCaptchaValue = _o[1];

  var optionsDropdown = reasonsDropdown.map(function (item) {
    return {
      value: item.value,
      label: item.label
    };
  });
  var optionSelected = optionsDropdown.find(function (opt) {
    return opt.value === emailFormState.Reason;
  });

  var onSubmit = function onSubmit() {
    return __awaiter(void 0, void 0, void 0, function () {
      var eFirstName, eSurName, eMessage, eReason, eEmailAddress, mailSent;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            eFirstName = (0, utils_1.InputTextValidation)(emailFormState.FirstName, 3, 24);
            setErrorFirstName(eFirstName);
            eSurName = (0, utils_1.InputTextValidation)(emailFormState.SurName, 4, 64);
            setErrorSurName(eSurName);
            eMessage = (0, utils_1.InputTextValidation)(emailFormState.Message, 1, 512);
            setErrorMessage(eMessage);
            eReason = "";

            if (!isSingleOption) {
              eReason = (0, utils_1.DropdownValidation)(emailFormState.Reason);
              setErrorReason(eReason);
            } else {
              eReason = (0, utils_1.InputTextValidation)(reasonsDropdown[0].label);
              setErrorReason(eReason);
            }

            eEmailAddress = (0, utils_1.InputEmailValidation)(emailFormState.EmailAddress);
            setErrorEmailAddress(eEmailAddress);
            setCaptchaMatch(captchaValue === captchaInput);
            setErrorCaptcha(!captchaMatch);
            if (!(!eFirstName && !eSurName && !eMessage && !eReason && !eEmailAddress && captchaMatch)) return [3
            /*break*/
            , 2];
            emailFormState.Origin = pageOrigin;
            emailFormState.Version = version;

            if (!isSingleOption) {
              emailFormState.Reason = optionSelected.label;
            } else {
              emailFormState.Reason = reasonsDropdown[0].label;
            }

            return [4
            /*yield*/
            , (0, email_form_1.sendEmail)(emailFormState, apiHost, apiParcel)];

          case 1:
            mailSent = _a.sent();
            setIsEmailSent(mailSent);
            _a.label = 2;

          case 2:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var onCaptchaRefresh = function onCaptchaRefresh() {
    setCaptchaValue((0, utils_1.randomString)(6));
  };

  return react_1["default"].createElement("section", {
    className: "w-full"
  }, isEmailSent && react_1["default"].createElement(components_1.ContainerSection, {
    theme: theme
  }, react_1["default"].createElement(elements_1.Title, {
    theme: theme,
    marginBottom: true,
    paddingTop: true
  }, localizedTexts.sentEmailTitle), react_1["default"].createElement(elements_1.TextRegular, {
    theme: theme
  }, localizedTexts.sentEmailText)), !isEmailSent && react_1["default"].createElement("form", {
    onSubmit: onSubmit
  }, react_1["default"].createElement(components_1.ContainerSection, {
    theme: theme,
    paddingTop: true
  }, react_1["default"].createElement("fieldset", {
    className: "flex flex-col w-full"
  }, react_1["default"].createElement(elements_1.TitleAbstract, {
    theme: theme,
    marginBottom: true,
    marginTop: true
  }, localizedTexts.legendPerson), react_1["default"].createElement("div", {
    className: "flex flex-col md:flex-row"
  }, react_1["default"].createElement("div", {
    className: "w-full md:w-1/2 md:mr-2"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formFirstname,
    type: "text",
    id: "firstName",
    name: "firstName",
    value: emailFormState.FirstName || "",
    placeholderText: localizedTexts.formFirstnamePlaceholder,
    onInputChanged: function onInputChanged(FirstName) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        FirstName: FirstName
      }));
    },
    error: errorFirstName
  })), react_1["default"].createElement("div", {
    className: "w-full md:w-1/2 md:ml-2 mt-6 md:mt-0"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formSurname,
    type: "text",
    id: "surName",
    name: "surName",
    value: emailFormState.SurName || "",
    placeholderText: localizedTexts.formSurnamePlaceholder,
    onInputChanged: function onInputChanged(SurName) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        SurName: SurName
      }));
    },
    error: errorSurName
  }))), react_1["default"].createElement("div", {
    className: "w-full mt-6"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formEmail,
    type: "email",
    id: "emailAddress",
    name: "emailAddress",
    value: emailFormState.EmailAddress || "",
    placeholderText: localizedTexts.formEmailPlaceholder,
    onInputChanged: function onInputChanged(EmailAddress) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        EmailAddress: EmailAddress
      }));
    },
    error: errorEmailAddress
  })), react_1["default"].createElement("div", {
    className: "flex flex-col md:flex-row mt-6"
  }, react_1["default"].createElement("div", {
    className: "w-full md:w-2/3 md:mr-2"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formStreet,
    type: "text",
    id: "street",
    name: "street",
    value: emailFormState.Street,
    placeholderText: localizedTexts.formStreetPlaceholder,
    onInputChanged: function onInputChanged(Street) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        Street: Street
      }));
    }
  })), react_1["default"].createElement("div", {
    className: "w-full md:w-1/3 md:ml-2 mt-6 md:mt-0"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formNumber,
    type: "number",
    id: "number",
    name: "number",
    value: emailFormState.Number,
    placeholderText: localizedTexts.formNumberPlaceholder,
    onInputChanged: function onInputChanged(Number) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        Number: Number
      }));
    }
  }))), react_1["default"].createElement("div", {
    className: "flex flex-col md:flex-row mt-6"
  }, react_1["default"].createElement("div", {
    className: "w-full md:w-2/3 md:mr-2"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formCity,
    type: "text",
    id: "city",
    name: "city",
    value: emailFormState.City,
    placeholderText: localizedTexts.formCityPlaceholder,
    onInputChanged: function onInputChanged(City) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        City: City
      }));
    }
  })), react_1["default"].createElement("div", {
    className: "w-full md:w-1/3 md:ml-2 mt-6 md:mt-0"
  }, react_1["default"].createElement(elements_1.Input, {
    theme: theme,
    label: localizedTexts.formPostcode,
    type: "text",
    id: "postcode",
    name: "postcode",
    value: emailFormState.PostCode,
    placeholderText: localizedTexts.formPostcodePlaceholder,
    onInputChanged: function onInputChanged(PostCode) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        PostCode: PostCode
      }));
    }
  }))))), react_1["default"].createElement(components_1.ContainerSection, {
    theme: theme,
    marginTop: true
  }, react_1["default"].createElement("fieldset", {
    className: "flex flex-col w-full"
  }, react_1["default"].createElement(elements_1.TitleAbstract, {
    theme: theme,
    marginBottom: true,
    marginTop: true
  }, localizedTexts.legendReason), react_1["default"].createElement("div", {
    className: "w-full"
  }, isSingleOption ? react_1["default"].createElement("span", null, react_1["default"].createElement(elements_1.Label, {
    theme: theme
  }, localizedTexts.formReason + ": " + optionsDropdown[0].label), " ") : react_1["default"].createElement(elements_1.Dropdown, {
    label: localizedTexts.formReason,
    id: "reason",
    name: "reason",
    theme: theme,
    options: optionsDropdown,
    onSelectionChanged: function onSelectionChanged(Reason) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        Reason: Reason
      }));
    },
    error: errorReason
  })), react_1["default"].createElement("div", {
    className: "w-full mt-6"
  }, react_1["default"].createElement(elements_1.Textarea, {
    id: "message",
    name: "message",
    label: localizedTexts.formMessage,
    theme: theme,
    placeholderText: localizedTexts.formMessagePlaceholder,
    onInputChanged: function onInputChanged(Message) {
      return setEmailFormState(__assign(__assign({}, emailFormState), {
        Message: Message
      }));
    },
    error: errorMessage
  })))), react_1["default"].createElement(components_1.ContainerSection, {
    theme: theme,
    marginTop: true
  }, react_1["default"].createElement("div", {
    className: "flex justify-center w-full mt-8 mb-8"
  }, react_1["default"].createElement(image_captcha_1.ImageCaptcha, {
    apiHost: apiHost,
    apiParcel: apiParcel,
    theme: theme,
    value: captchaValue,
    captchaInput: captchaInput,
    onCaptchaChange: setCaptchaInput,
    onCaptchaRefresh: onCaptchaRefresh,
    error: errorCaptcha
  })), react_1["default"].createElement("div", {
    className: "flex justify-center w-full"
  }, react_1["default"].createElement(elements_1.ButtonRegular, {
    onClick: onSubmit,
    text: localizedTexts.formButtonSend,
    size: elements_1.ButtonSize.normal,
    type: elements_1.ButtonType.secondary
  })))));
};

exports.ContactFormRegular = ContactFormRegular;